import { render, staticRenderFns } from "./ModalLinkResource.vue?vue&type=template&id=0a5818b6&"
import script from "./ModalLinkResource.vue?vue&type=script&lang=js&"
export * from "./ModalLinkResource.vue?vue&type=script&lang=js&"
import style0 from "./ModalLinkResource.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports